import { usePrefetchPendingExperiments } from "@src/api/experiences/use-prefetch-pending-experiments";
import { usePrefetchPendingPersonalizations } from "@src/api/experiences/use-prefetch-pending-personalizations";

import { useGetShopDomain } from "../api/shops/get-domain";
import {
  useFetchCollectionsQuery,
  useFetchProductTagsQuery,
  useFetchProductTypesQuery,
  useFetchProductVendorsQuery,
} from "../generated";

export const usePrefetchQueries = () => {
  // Prefetch Pending experiences for faster loading
  void usePrefetchPendingExperiments();
  void usePrefetchPendingPersonalizations();

  // Prefetch experiment history for integration confirmations
  // void usePrefetchPendingExperimentsHistory();

  // get domain
  useGetShopDomain();

  // Pre-fetch shopify products
  useFetchCollectionsQuery();
  useFetchProductTypesQuery();
  useFetchProductVendorsQuery();
  useFetchProductTagsQuery();
};
